import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';
import { SET_SCREEN_NOTIFICATION, SET_NOTIFICATION, SEND_SLACK_NOTIFICATION, SPINNER_SMALL, SPINNER_ON, SPINNER_OFF, } from '../actions/types/CommonTypes';
import api from '../controllers/api/config';
export function enableSpinner(store, smallLoader) {
    if (smallLoader) {
        store.dispatch({
            type: SPINNER_SMALL,
            payload: {
                [smallLoader]: true,
            },
        });
    }
    else {
        store.dispatch({
            type: SPINNER_ON,
        });
    }
}
export function disableSpinner(store, smallLoader) {
    if (smallLoader) {
        store.dispatch({
            type: SPINNER_SMALL,
            payload: {
                [smallLoader]: false,
            },
        });
    }
    else {
        store.dispatch({
            type: SPINNER_OFF,
        });
    }
}
const checkCommon = (store) => (next) => (action) => {
    switch (action.type) {
        case SET_SCREEN_NOTIFICATION: {
            next(action);
            let notification = cloneDeep(get(store.getState(), 'common.notification', []));
            const errorExist = notification.filter((item) => item.type === action.payload.type && item.label === action.payload.label);
            let delaySetState = 0;
            if (action.payload.type === 'resetAll') {
                notification = [];
            }
            else if (errorExist.length === 0 && action.payload.state) {
                const checkAlert = notification.filter((item) => item.type === 'alert');
                if (action.payload.type === 'save' && checkAlert.length > 0)
                    notification = [action.payload];
                else
                    notification.push(action.payload);
            }
            else if (action.payload.type === 'save') {
                const getIndex = notification.findIndex((item) => item.type === action.payload.type);
                if (notification[getIndex])
                    notification[getIndex].state = action.payload.state;
                if (getIndex >= 0 && action.payload.action !== notification[getIndex].action) {
                    notification[getIndex].action = action.payload.action;
                }
                else if (action.payload.state) {
                    store.dispatch({ type: SET_NOTIFICATION, payload: cloneDeep(notification) });
                    delaySetState = 4000;
                }
            }
            else if (action.payload.state !== true) {
                const getIndex = notification.findIndex((item) => item.type === action.payload.type && item.label === action.payload.label);
                const getIndexSaveData = notification.findIndex((item) => item.action === 'saveData');
                if (notification[getIndex])
                    notification[getIndex].state = action.payload.state;
                if (notification[getIndexSaveData]) {
                    delete notification[getIndexSaveData].action;
                }
                store.dispatch({ type: SET_NOTIFICATION, payload: cloneDeep(notification) });
                delaySetState = 1000;
            }
            if (delaySetState === 0) {
                store.dispatch({ type: SET_NOTIFICATION, payload: notification });
            }
            else {
                setTimeout(() => {
                    notification = cloneDeep(get(store.getState(), 'common.notification', []));
                    const getIndex = notification.findIndex((item) => item.type === action.payload.type && item.label === action.payload.label);
                    if (getIndex >= 0)
                        notification.splice(getIndex, 1);
                    store.dispatch({ type: SET_NOTIFICATION, payload: notification || [] });
                }, delaySetState);
            }
            break;
        }
        // SEND SLACK NOTIFICATION
        case SEND_SLACK_NOTIFICATION: {
            next(action);
            const { data, channel, } = action.payload;
            api.common.sendSlackNotification(data, channel)
                .then((res) => {
                // eslint-disable-next-line no-console
                console.log(res);
            });
            break;
        }
        default:
            next(action);
    }
};
export default checkCommon;
